<div class="p-10" fxLayoutAlign="end center">
  <!-- <button
    mat-raised-button
    (click)="save('qr')"
    color="primary"
    *ngIf="arrive && depart && quantityCodesToPrint > 0"
    class="mr-8"
  >
    Enregistrer Qr Code
  </button> -->

  <button
    mat-raised-button
    (click)="save('bar')"
    class="bg-pink-800 text-white"
    *ngIf="
      validRef &&
      depart &&
      isValid('Depart', depart) &&
      ((arrive && isValid('Arriver', arrive)) ||
        (suiviFormGroup.value.destinationFlag &&
          suiviFormGroup.value.Colis_Arrive)) &&
      quantityCodesToPrint > 0
    "
  >
    Enregistrer Bar Code
  </button>
</div>

<mat-divider></mat-divider>
<div
  *ngIf="suiviFormGroup"
  [formGroup]="suiviFormGroup"
  fxLayout.gt-sm="row"
  fxLayout.lt-sm="column"
>
  <div class="p-20 w-100-p" fxFlex="50" fxFlex.xs="100">
    <unilog-recherche
      [(ngModel)]="depart"
      appearance="outline"
      champsModel="Site_Code"
      formControlName="Colis_Depart"
      champsAffiche="Site_Des"
      [ServerSideFiltering]="true"
      textErreur="Veuillez Entrer un tier valide"
      [showError]="true"
      recherche="SitesColisD"
      [api]="api"
      placeholder="Départ"
    >
    </unilog-recherche>
  </div>
  <mat-divider [vertical]="true"></mat-divider>
  <div class="p-20 w-100-p" fxFlex="49" fxFlex.xs="100">
    <ng-container *ngIf="suiviFormGroup.value.destinationFlag">
      <unilog-recherche
        [(ngModel)]="arrive"
        appearance="outline"
        champsModel="Site_Code"
        formControlName="Colis_Arrive"
        champsAffiche="Site_Des"
        [ServerSideFiltering]="true"
        recherche="SitesColisA"
        [api]="api"
        placeholder="Arrive"
      >
      </unilog-recherche>
    </ng-container>
    <ng-container *ngIf="!suiviFormGroup.value.destinationFlag">
      <unilog-recherche
        [(ngModel)]="arrive"
        appearance="outline"
        champsModel="Site_Code"
        formControlName="Colis_Arrive"
        champsAffiche="Site_Des"
        [ServerSideFiltering]="true"
        textErreur="Veuillez Entrer un site valide"
        [showError]="true"
        recherche="SitesColisA"
        [api]="api"
        placeholder="Arrive"
      >
      </unilog-recherche>
    </ng-container>
    <mat-slide-toggle  formControlName="destinationFlag"[(ngModel)]="externeToggle"
      >Externe</mat-slide-toggle
    >
  </div>
</div>
<mat-divider></mat-divider>
<div
  *ngIf="suiviFormGroup"
  [formGroup]="suiviFormGroup"
  class="p-20 grid lg:grid-cols-5 md:grid-cols-2 sm:grid-cols-1 gap-4"
>
  <div class="grid">
    <mat-form-field appearance="outline" [color]="!validRef ? 'red' : ''">
      <mat-label>Référence</mat-label>
      <input
        (blur)="checkValidRef()"
        [(ngModel)]="reference"
        formControlName="Colis_Ref"
        type="text"
        matInput
        placeholder="Référence"
      />
    </mat-form-field>
    <div class="text-red-500" *ngIf="!validRef">
      vous avez déjà utilisé cette référence
    </div>
  </div>

  <mat-form-field appearance="outline">
    <mat-label>Désignation</mat-label>
    <input
      formControlName="Colis_Texte"
      type="text"
      matInput
      placeholder="Désignation"
    />
  </mat-form-field>

  <!-- TODO: formControlName -->
  <unilog-recherche
    appearance="outline"
    champsModel="Machine_Serie"
    formControlName="Colis_Arrive"
    champsAffiche="Machine_Serie"
    [ServerSideFiltering]="true"
    textErreur="Veuillez Entrer un site valide"
    [showError]="true"
    recherche="Voitures"
    [api]="api"
    placeholder="Voiture"
  >
  </unilog-recherche>

  <!-- TODO: formControlName -->
  <unilog-recherche
    appearance="outline"
    champsModel="Perso_Code"
    formControlName="Colis_Arrive"
    champsAffiche="Perso_Prenom"
    [ServerSideFiltering]="true"
    textErreur="Veuillez Entrer un site valide"
    [showError]="true"
    recherche="Chauffeurs"
    [api]="api"
    placeholder="Chauffeur"
  >
  </unilog-recherche>
  <mat-form-field appearance="outline">
    <mat-label>Quantité</mat-label>
    <input
      matInput
      placeholder="Quantité"
      [(ngModel)]="quantityCodesToPrint"
      [ngModelOptions]="{ standalone: true }"
    />
  </mat-form-field>
</div>
<mat-divider></mat-divider>
<div
  class="w-full text-center justify-center flex flex-wrap fixed"
  style="left: -999999999px "
>
  <img
    *ngFor="let codeImg of listCodes; index as i"
    [id]="'imgCode' + i"
    [style]="printingType == 'qr' ? 'width: 15% ' : 'width: 25% '"
  />
</div>

<div
  role="alert"
  class="fixed bottom-2 right-2 w-2/6 opacity-0"
  [ngClass]="{ showAlert: showAlertFail }"
>
  <div class="bg-red-500 text-white font-bold rounded-t px-16 py-8">
    Erreur !
  </div>
  <div
    class="
      border border-t-0 border-red-400
      rounded-b
      bg-red-100
      px-16
      py-8
      text-red-700
    "
  >
    <p>Un problème est survenu, veuillez réessayer C-V-P</p>
  </div>
</div>
